export default __webpack_public_path__ + "static/media/noImage.a955a907.bmp";